<template>
  <v-card id="create">
    <!-- Speed Dial (only buttons) -->
    <v-speed-dial
      v-model       = "fab"
      :top          = "top"
      :bottom       = "bottom"
      :right        = "right"
      :left         = "left"
      :direction    = "direction"
      :open-on-hover= "hover"
      :transition   = "transition"
    >
      <template v-slot:activator>
        <v-btn large v-model="fab" color="#003399" dark fab>
          <v-icon v-if="fab">mdi-close</v-icon>
          <v-icon v-else>mdi-account-question-outline</v-icon>
        </v-btn>
      </template>

      <!-- FAQs -->
      <v-tooltip left>
        <template v-slot:activator="{ on, attrs }">
          <v-btn fab dark color="green" v-bind="attrs" v-on="on" to="/faqs">
            <v-icon>mdi-frequently-asked-questions</v-icon>
          </v-btn>
        </template>
        <span>FAQs</span>
      </v-tooltip>

      <!-- Contact Us -->
      <v-tooltip left v-if="$can('contact_us_create') && isAuthenticated">
        <template v-slot:activator="{ on, attrs }">
          <v-btn fab dark color="indigo" v-bind="attrs" v-on="on" @click="changeContactCardState">
            <v-icon>mdi-forum</v-icon>
          </v-btn>
        </template>
        <span>Contact Us</span>
      </v-tooltip>

      <!-- Accessibility Button -->
      <v-tooltip left>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            fab
            dark
            color="teal"
            v-bind="attrs"
            v-on="on"
            @click="openAccessibilityOptions"
            aria-label="Open accessibility options"
          >
            <v-icon>mdi-human</v-icon>
          </v-btn>
        </template>
        <span>Accessibility</span>
      </v-tooltip>
    </v-speed-dial>

    <!-- Accessibility Drawer – NOW OUTSIDE the speed-dial -->
    <v-navigation-drawer
      v-model="showA11yDrawer"
      right
      temporary
      width="380"
      app
    >
      <v-toolbar flat dense color="primary" dark>
        <v-toolbar-title class="text-subtitle-1">Accessibility Options</v-toolbar-title>
        <v-spacer />
        <v-btn icon @click="showA11yDrawer = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-divider />

      <div class="pa-6">
        <AccessibilityToolbar
          invert-colors-text="Invert page colors"
          highlight-links-text="Highlight all links"
          grayscale-text="Desaturate page"
          accessibile-font-size-text="Increase text size"
        />
      </div>

      <v-card-text class="text-caption grey--text px-6 pb-6">
        Changes apply instantly and are saved in your browser.
      </v-card-text>
    </v-navigation-drawer>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  data: () => ({
    direction: "top",
    fab: false,
    hover: true,
    top: false,
    right: true,
    bottom: true,
    left: false,
    transition: "slide-y-reverse-transition",
    showA11yDrawer: false,
  }),

  watch: {
    top(val) { this.bottom = !val; },
    right(val) { this.left = !val; },
    bottom(val) { this.top = !val; },
    left(val) { this.right = !val; },
  },

  methods: {
    ...mapActions(["changeContactCardState"]),

    openAccessibilityOptions() {
      this.fab = false;           // close dial
      this.$nextTick(() => {
        this.showA11yDrawer = true; // open drawer safely
      });
    },
  },
  computed: {
    ...mapGetters([
      "isAuthenticated"
      ]),
  },

};
</script>

<style>
/* Existing speed-dial positioning */
#create .v-speed-dial {
  position: fixed;
}
#create .v-btn--floating {
  position: fixed;
}

/* Make sure drawer is always on top */
.v-navigation-drawer {
  z-index: 9999 !important;
}
</style>